<template>
	<v-row>
		<BottomNavigationContainer v-if="menu.length > 1" :menu="menu" />

		<v-col cols="12" class="d-none d-md-block">
			<ToolbarContainer :menu="menu" />
			<v-toolbar elevation="1" height="25" rounded="b">
				<Breadcrumbs />
			</v-toolbar>
		</v-col>

		<v-col cols="12" lg="12">
			<router-view />
		</v-col>
	</v-row>
</template>

<script>
import Breadcrumbs from "../Widgets/Breadcrumbs";
import ToolbarContainer from "../Widgets/ToolbarContainer";
import BottomNavigationContainer from "../Widgets/BottomNavigationContainer";

export default {
	name: "BalancoContainer",
	components: { Breadcrumbs, ToolbarContainer, BottomNavigationContainer },
	data: () => ({
		menu: [],
	}),
	methods: {
		montarMenu() {
			let m = [];

			if (this.permissao("balanco_exportar")) {
				m.push({
					titulo: "Exportador balanço",
					titulo_app: "Exportador balanço",
					icon: "mdi-store-outline",
					to: "/balanco",
					tooltip: "Exportar arquivos para balanços",
				});
			}

			if (this.permissao("balanco_importador")) {
				m.push({
					titulo: "Importador balanço",
					titulo_app: "Importador balanço",
					icon: "mdi-store-outline",
					to: "/balanco/importar",
					tooltip: "Importar arquivos de balanços realizados",
				});
			}

			if (this.permissao("balanco_listar")) {
				m.push({
					titulo: "Balanço",
					titulo_app: "Balanço",
					icon: "mdi-store-outline",
					to: "/balanco/listar",
					tooltip: "Lista de balanços realizados",
				});
			}

			this.menu = m;
		},
	},
	mounted() {
		this.montarMenu();
	},
};
</script>

<style scoped>
</style>